/*
 * *****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from "@ngrx/store";
import { MessageService } from "./message.service";
import { Message } from "CalltakingCoreApi";
import { deleteSystemErrorMessage, newSystemErrorMessage, updateSystemErrorMessage } from "../+state/message.actions";
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
  providedIn: 'root'
})
export class SystemErrorMessageService extends MessageService {

    constructor(
        private http: HttpClient,
        protected store: Store,
        protected stompManager: StompManagerService
    ) {
        super('SYSTEM_ERROR', store, stompManager);
    }

    protected getTopics(): Topic[] {
        return [Topic.MESSAGES_SYSTEM_ERROR_NEW, Topic.MESSAGES_SYSTEM_ERROR_EDIT, Topic.MESSAGES_SYSTEM_ERROR_DELETE];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any) => void } {
        return {
            [Topic.MESSAGES_SYSTEM_ERROR_NEW]: this.newMessage.bind(this),
            [Topic.MESSAGES_SYSTEM_ERROR_EDIT]: this.editMessage.bind(this),
            [Topic.MESSAGES_SYSTEM_ERROR_DELETE]: this.deleteMessage.bind(this)
        };
    }

    protected effectsInitialized(): void {
    }

    protected websocketInitialized(): void {
    }

    protected deleteMessage(message: Message): void {
        this.store.dispatch(deleteSystemErrorMessage({ message }));
    }

    protected editMessage(message: Message): void {
        this.store.dispatch(updateSystemErrorMessage({ message }));
    }

    protected newMessage(message: Message): void {
        this.store.dispatch(newSystemErrorMessage({ message }));
    }
}
